// extracted by mini-css-extract-plugin
module.exports = {"card":"Content3_card__1Ett5","title":"Content3_title__1KcLp","partnerWrapper":"Content3_partnerWrapper__1S927","partnerCard":"Content3_partnerCard__1tI7E"};